import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const el = document.querySelector(".work-about__main-text");

if (el) {
  const words = el.textContent.trim().split(/\s+/).filter(Boolean);

  el.innerHTML = words
    .map((word) => `<span class="word">${word} </span>`)
    .join("");

  const wordSpans = el.querySelectorAll(".word");

  gsap.set(wordSpans, { color: "rgba(12, 12, 12, 0.15)" });

  gsap.to(wordSpans, {
    color: "#0C0C0C",
    stagger: 0.08,
    scrollTrigger: {
      trigger: el,
      start: "top 85%",
      end: "bottom center",
      scrub: true
    }
  });
}


// header //
const header = document.querySelector(".header");

if (header) {
  // Single work has no dark hero — keep dark header always visible on light bg
  header.classList.add("header--dark");
}


const elements = document.querySelectorAll(".project-details__item");
const observerLines = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
      } else {
        entry.target.classList.remove("active");
      }
    });
  },
  {
    threshold: 0.2
  }
);

elements.forEach((item) => observerLines.observe(item));
